import React, { useCallback, useState } from 'react'
import "./ModalSelectScheduleEmail.css"
import moment, { Moment } from 'moment'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import ConfirmButton from '../../../../UIcomponents/Modals/ConfirmButton/ConfirmButton'
import { useTranslation } from 'react-i18next'
import InputList from '../../../../UIcomponents/InputList/InputList'
import { DayOfWeek, Schedule } from '../../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice';
import { FrecuencyEmailId } from '../../../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice';
import { ScheduleFrecuency } from '../../../../ScheduleNotification/CreateScheduleNotification/CreateScheduleNotificationForm/CreateScheduleNotificationForm';
import ItemListEmail from '../../CreateScheduleEmailForm/ItemListEmail/ItemListEmail';

type WeekDayEmail = {
    id:     DayOfWeek
    text:   string
}

type ModalSelectScheduleEmailProps = {
    schedule?: Schedule
    frecuencyId: FrecuencyEmailId
    onCloseModal: () => void
    onSet: (schedule: ScheduleFrecuency) => void
}

const ModalSelectScheduleEmail = ({
    schedule,
    frecuencyId,
    onCloseModal,
    onSet
}: ModalSelectScheduleEmailProps) => {

    const { t } = useTranslation()

    /*
    let initialDay = undefined
    if(schedule){
        let momentInitital = moment()
        if(schedule.dayOfMonth && schedule.dayOfMonth !== "*"){
            momentInitital
        }
    }
*/
    const [loading, setLoading] = useState(false)
    const [daySelected, setDaySelected] = useState<Moment | undefined>(undefined)
    const [hourSelected, setHourSelected] = useState<Moment | undefined>(undefined)
    const [error, setError] = useState("")
    console.log(" ")
    console.log("daySelected", daySelected?.toISOString())
    console.log("hourSelected", hourSelected?.toISOString())
    const weekDays: WeekDayEmail[] = [
        { id: "MON", text: t(`Emails:schedule:${"MON"}`) },
        { id: "TUE", text: t(`Emails:schedule:${"TUE"}`) },
        { id: "WED", text: t(`Emails:schedule:${"WED"}`) },
        { id: "THU", text: t(`Emails:schedule:${"THU"}`) },
        { id: "FRI", text: t(`Emails:schedule:${"FRI"}`) },
        { id: "SAT", text: t(`Emails:schedule:${"SAT"}`) },
        { id: "SUN", text: t(`Emails:schedule:${"SUN"}`) },
    ]
    const [weekDaySelected, setWeekDaySelected] = useState<DayOfWeek | undefined>(undefined)

    const getSchedule = (): ScheduleFrecuency => {

        if(!hourSelected){
            throw(`You must select an hour`)
        }

        if(frecuencyId === "One_time"){
            
            if(!daySelected){
                throw(`You must select a day`)
            }
            return {
                id: "One_time",
                utcDate: daySelected.toISOString(),
                utcHour: hourSelected?.toISOString()
            }
        }else if(frecuencyId === "Every_day"){
            return {
                id: "Every_day",
                utcHour: hourSelected?.toISOString()
            }
        }else if(frecuencyId === "Every_week"){
            if(!weekDaySelected){
                throw("You must select a week day")
            }
            return {
                id: "Every_week",
                utcHour: hourSelected?.toISOString(),
                weekDay: weekDaySelected
            }
        }else{
            if(!daySelected){
                throw("You must select a day")
            }
            return {
                id: "Every_month",
                utcDate: daySelected.toISOString(),
                utcHour: hourSelected?.toISOString()
            }
        }
    }

    const onSubmit = (e: any) => {
        e.preventDefault();

        try {
            const scheduleFrecuency = getSchedule()

            console.log("schedule modal", scheduleFrecuency)
            onSet(scheduleFrecuency)
            onCloseModal()
        } catch (error: any) {
            setError(error)
        }

        
    }

    const onChangeWeekDay = (item: WeekDayEmail) => {
        setWeekDaySelected(item.id)
    }
    console.log("check", daySelected?.date(), hourSelected?.date())
    console.log("llll", daySelected?.date() === hourSelected?.date()
                        ? moment().toISOString()
                        : moment().startOf("day").toISOString())
    return (
        <div className="modal-schedule-notif flex flex-d-column">
            <p className="fs-18 fw-600">
                {"Schedule for later"}
            </p>

            <form onSubmit={onSubmit} className="flex flex-d-column flex-1 mt-20">
                
                {
                    (frecuencyId === "One_time" || frecuencyId === "Every_month")
                    ?
                    <React.Fragment>
                        <p className="fs-14 fw-600 mb-10">{"Date"}</p>
                        <DatePicker
                            //id={inputID}
                            className="time-picker-input-notif-day center pointer"
                            selected={daySelected ? daySelected.toDate() : undefined}
                            onChange={(date: Date | null) => {
                                if (date) 
                                    setDaySelected(moment(date.toISOString()))
                                setError("")
                            }}
                            placeholderText={"Select day"}
                            showTimeSelect={false}
                            showTimeSelectOnly={false}

                            dateFormat="dd/MM"

                            showPopperArrow={false}

                            minDate={moment().startOf("day").toDate()}
                            //maxDate={moment().add(1, "month").endOf("month").startOf("day").toDate()}
                        />
                    </React.Fragment>
                    : null
                }

                <p className="fs-14 fw-600 mt-30 mb-10">{"Hour"}</p>
                <DatePicker 
                    className="time-picker-input-notif-day center"
                    selected={hourSelected ? hourSelected.toDate() : undefined} 
                    onChange={(date: Date| null) => {
                        //console.log("date", date)
                        //console.log("date end", moment(date.toISOString()))
                        if(date)
                            setHourSelected(moment(date.toISOString()))
                        setError("")
                    }} 
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}  
                    timeCaption="Time"
                    dateFormat="HH:mm"
                    placeholderText="Select time"
                    
                    minTime={
                        daySelected?.date() === moment().add(5, "minutes").date()
                        ? moment().toDate()
                        : moment().startOf("day").toDate()
                        //moment(slotRequested?.slot.startTime).add(25, "minutes")
                        //.set({ hour: 20, minute: 40, second: 0, millisecond: 0 })
                    }
                    
                    maxTime={
                        moment().endOf("day")
                        //.set({ hour: 23, minute: 55, second: 0, millisecond: 0 })
                        .toDate()
                    }
                      
                />
                
                {
                    frecuencyId === "Every_week" ?
                    <React.Fragment>
                        <p className="fs-14 fw-600 mt-30 mb-10">{"Week day"}</p>
                        <InputList 
                            text={weekDays.find(s => s.id === weekDaySelected)?.text ?? ""}  
                            width={"100%"}
                            fontSize="fs-11"
                            heightList="22rem"
                            height="3.4rem"
                        >
                            {
                                weekDays.filter(i => i.id !== weekDaySelected).map((notif: WeekDayEmail) => {
                                    return(
                                        <ItemListEmail 
                                            key={notif.id}
                                            item={notif}
                                            text={notif.text}
                                            onSelect={onChangeWeekDay}
                                        />
                                    )
                                })
                            }
                        </InputList>
                    </React.Fragment>
                    : null
                }
                
                <div className="flex-1 flex flex-d-column flex-jc-end">
                    <div className="relative mb-10">
                        <p className="absolute color-error fs-11">
                            {error}
                        </p>
                    </div>
                    <ConfirmButton text={t("General:label_131")} width="100%" />
                </div>
            </form>
            
        </div>
    )
}

export default React.memo( ModalSelectScheduleEmail )